import LazyLoad from 'react-lazyload';
import { LocalCars } from './LocalCars';
import useAppState from '../../../common/state/appState';
import HomePageExperience from '../hero/store/HomePageExperience';

export const LocalCarsLoader: React.FC = () => {
    const experience = useAppState((state) => state.experience);
    const isUFTTestActive = useAppState((state) => state.serveUFTContent);

    if (experience === HomePageExperience.ReturnVisitor || isUFTTestActive) {
        return <></>;
    }

    return (
        <LazyLoad height={window.innerHeight}>
            <LocalCars />
        </LazyLoad>
    );
};
